export default "__VITE_ASSET__h4voQKuK__"